module.exports = __webpack_public_path__ + "a191682bbeef3539f9fe15a831a97f40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-13.png
// module id = 1166
// module chunks = 0